<template>
  <header class="home-header">
    <a class="brand" href="/">
      <img class="brand-avatar" :src="config.avatarUrl" :alt="config.siteName">
      <span class="brand-text">{{ config.logoText || config.siteName }}</span>
    </a>

    <div class="header-tools">
      <div class="time-card">
        <div class="date-line">
          <AppIcon name="clock" />
          <span>{{ dateText }}</span>
        </div>
        <div class="time-line">
          <strong>{{ timeText }}</strong>
          <AppIcon name="sun" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import AppIcon from './AppIcon.vue';

export default {
  name: 'HomeHeader',
  components: { AppIcon },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      now: new Date(),
      timer: null
    };
  },
  computed: {
    dateText() {
      const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
      const y = this.now.getFullYear();
      const m = String(this.now.getMonth() + 1).padStart(2, '0');
      const d = String(this.now.getDate()).padStart(2, '0');
      return `${y} 年 ${m} 月 ${d} 日 星期${weekdays[this.now.getDay()]}`;
    },
    timeText() {
      const h = String(this.now.getHours()).padStart(2, '0');
      const m = String(this.now.getMinutes()).padStart(2, '0');
      const s = String(this.now.getSeconds()).padStart(2, '0');
      return `${h}:${m}:${s}`;
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
